import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DDatosCompartidosCabecera } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../services/message-observable.service';
import { DLiquidacionRecibo, DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';

interface InfoPago {
  liquidacion: DLiquidacionRecibo,
  reciboPago: DRtaLiquidacionReciboPago
}

@Component({
  selector: 'app-contenedor-formulario',
  templateUrl: './contenedor-formulario.component.html',
  styleUrls: ['./contenedor-formulario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ContenedorFormularioComponent implements OnInit {

  @ViewChild('scrollContainerForm') scrollContainerForm: ElementRef;

  public loading: boolean = true;
  public showHelp: boolean = false;
  public helpTitle: string = '';
  public helpText: string = '';
  public showBtnDeclaSug: boolean = false;
  public showSaveButton: boolean = false;
  public showPDFButton: boolean = false;
  public dataForm: DDatosCompartidosCabecera = new DDatosCompartidosCabecera();
  public infoPago: InfoPago;
  public showDataReciboPago: boolean = false;
  public fechaPago: Date = new Date();
  public guardadoReciboPago: boolean = false;
  public listCuotas: Array<number> = new Array<number>();
  public higlightHelp: boolean = true;
  public disabledDatePago: boolean = false;

  private stepsHideSaveButton = [13];

  constructor(
    private _messagesObs: MessageObservableService
  ) {}

  ngOnInit(): void {
    this.listenMessagesObs();
  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'info-form') {
        this.dataForm = res.message;
        this.loading = false;
      }        

      if (res.operation === 'help') {
        this.helpTitle = res.message.title;
        this.helpText = res.message.text;
        this.showHelp = true;
        this.higlightHelp = true;

        setTimeout(() => this.higlightHelp = false, 3000);
      }   
      
      if (res.operation === 'show-declasug')
        this.showBtnDeclaSug = true;

      if (res.operation === 'index-tab-stepper') {
        if (res.message.tab === 0)
        {
          this.showSaveButton = false;
          this.showPDFButton = false;
        } 
        else {
          if (this.stepsHideSaveButton.indexOf(res.message.stepper) > -1)
            this.showSaveButton = false;
          else this.showSaveButton = true;
          if(this.dataForm.numFormulario != -1)
            this.showPDFButton = true;
          else
            this.showPDFButton = false;
        }
      }

      if (res.operation === 'recibo-pago-visualizar') {
        this.infoPago = res.message;
        this.showDataReciboPago = true;
      }

      if (res.operation === 'recibo-pago-guardado') 
        this.guardadoReciboPago = res.message;
      
      if (res.operation === 'lista-cuotas-recibo-pago')
        this.listCuotas = res.message;

      if (res.operation === '490-position-tab')
        this.disabledDatePago = res.message > 0;
      
      if (res.operation === 'scroll-to-top') {        
        //this.scrollContainerForm.nativeElement.scrollIntoView({ behavior: 'smooth' });
        this.scrollContainerForm.nativeElement.scrollTo({ left: 0, top: 0 });
      }
    });
  }

  showDeclaSug() {
    this._messagesObs.sendMessages('open-decla-sug', true);
  }

  saveForm() {
    this._messagesObs.sendMessages('save-form', true);
  }

  pdfForm() {
    this._messagesObs.sendMessages('pdf-form', true);
  }

  calcularInteresRecibo() {
    this._messagesObs.sendMessages('calcular-intereses', true);
  }

  changeFechaPago() {
    this._messagesObs.sendMessages('change-fechapago', this.fechaPago);
  }

  clearMessage() {
    this.showHelp = false;
    this.helpTitle = '';
    this.helpText = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-experto/contenedor-formulario/contenedor-formulario.component.ts